import {
  GetPlansFailureAction,
  GetPlansRequestAction,
  GetPlansSuccessAction,
  PlanById
} from './plans.types';

export const getPlans = (): GetPlansRequestAction => ({
  type: 'GET_PLANS_REQUEST'
});

export const getPlansSuccess = (data: PlanById): GetPlansSuccessAction => ({
  type: 'GET_PLANS_SUCCESS',
  payload: data
});

export const getPlansFailure = (error: string): GetPlansFailureAction => ({
  type: 'GET_PLANS_FAILURE',
  payload: error
});
